import axios from 'axios'
import { POLTRONA_GRATUITA_DISPONIVEL } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function poltronaGratuiraDisponivel (idEmpresa, idItinerario) {
  const url = `${URL}/reserva/empresa/${idEmpresa}/itinerario/${idItinerario}/venda-gratuidade`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: POLTRONA_GRATUITA_DISPONIVEL,
        payload: response

      })
  );
}
